export const GET_APPLICATION = gql`
    query RetrieveMerchantApplication($id: Int!) {
        retrieveMerchantApplication(id: $id) {
            id
            status
            businessInformation
            merchantInformation
            partnerId
            partnerOfPartnerId
            serviceRequirements
            outletInformation
            supportingDocuments
            country
            terminalId
            authorId
            mid
            isServiceApplication
            worldpayPO
            merchantAccountNumber
            sentToWorldpayAt
            tradingName
            partner {
                firstName
                lastName
                business {
                    legalName
                }
                countryDetails {
                    alpha2Code
                    currencies {
                        symbol
                    }
                }
            }
            partnerOfPartner {
                firstName
                lastName
                business {
                    legalName
                }
            }
            adobeSignJobs {
                jobId
                principalSignatureIndex
            }
            author {
                firstName
                lastName
                email
            }
            service {
                expiryDate
                serviceNumber
            }
            merchant {
                id
                merchantAccountNumber
            }
            agreementDocumentUrl
            agreementDocumentBytes
        }
    }
`;

export const GET_LATEST_ADOBE_SIGN_JOB = gql`
    query LatestAdobeSignJob($applicationId: Int!) {
        latestAdobeSignJob(applicationId: $applicationId) {
            id
            jobId
            notifiedAt
            applicationId
            createdAt
            canResend
        }
    }
`;

export const CANCEL_MERCHANT_APPLICATION = gql`
    mutation CancelMerchantApplication($applicationIds: [Int!]!) {
        cancelMerchantApplication(applicationIds: $applicationIds)
    }
`;

export const GET_APPLICATION_BY_SERVICE_ID = gql`
    query GetApplicationByServiceId($serviceId: Int!) {
        getApplicationByServiceId(serviceId: $serviceId)
    }
`;
export const GET_APPLICATION_BY_SERVICE_NUMBER = gql`
    query GetApplicationByServiceNumber($serviceNumber: String!) {
        getApplicationByServiceNumber(serviceNumber: $serviceNumber)
    }
`;

export const CONTINUE_TRIAL_MERCHANT_SERVICE = gql`
    mutation trialMerchantContinueService($input: TrialMerchantContinueServiceInput!) {
        trialMerchantContinueService(input: $input)
    }
`;
